<button [ngClass]="{ 'is-active': isOpen }"
        class="hamburger hamburger--collapse">
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
</button>
